// Keep the genuine CMS history and full roster; make the logo wall the primary client presentation.
export default function formatAbout() {
    const content = document.querySelector('[data-ss-about-content]');
    if (!content) return;
    const root = content.closest('.ss-about');
    if (!root) return;
    const heading = Array.from(content.querySelectorAll('p, h2, h3')).find(p => ["SOME OF THE AFFILIATES/GYMS WE'VE SUPPLIED:", 'THE SOLID STRENGTH EQUIPMENT NETWORK'].includes(p.textContent.trim()));
    const roster = heading && heading.nextElementSibling;
    if (roster && ['P', 'DIV'].includes(roster.tagName) && roster.querySelector('br')) {
        const names = roster.innerHTML.split(/<br\s*\/?\s*>/i).map((item) => {
            const fragment = document.createElement('span');
            fragment.innerHTML = item;
            return fragment.textContent.trim();
        }).filter(Boolean);
        const section = document.createElement('details');
        section.className = 'ss-client-roster';
        const title = document.createElement('summary');
        title.textContent = 'Explore our wider gym network';
        const list = document.createElement('ul');
        Array.from(new Set(names)).forEach((name) => {
            const item = document.createElement('li');
            item.textContent = name;
            list.appendChild(item);
        });
        section.append(title, list);
        (root.querySelector('[data-ss-client-history]') || root).appendChild(section);
        heading.remove();
        roster.remove();
    }
    // The legacy story is a single .mhl div separated by line breaks and blank lines.
    // Only normalize this known shape. Revised CMS structures remain untouched.
    content.querySelectorAll('div.mhl').forEach((block) => {
        if (!block.querySelector('br') || block.querySelector('p, div, h2, h3, ul, ol')) return;
        const paragraphs = document.createDocumentFragment();
        block.innerHTML.split(/<br\s*\/?\s*>/i).forEach((html) => {
            const paragraph = document.createElement('p');
            paragraph.innerHTML = html;
            if (paragraph.textContent.trim()) paragraphs.appendChild(paragraph);
        });
        block.replaceWith(paragraphs);
    });
}
